import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { map, keys } from 'lodash';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import ItemStatus from '../../../shared/components/ItemStatus/ItemStatus';
import styles from './servicesStatus.module.scss';

export default memo(function ServicesStatus(props) {
    const [t] = useTranslation(['common', 'dashboard']);
    const totalServices = useMemo(() => keys(props.services).length - 1);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <span>{props.title}</span>
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={props.description}
                    >
                        <span>{props.description}</span>
                    </Tooltip>
                </div>
                {props.fetching && <CircularLoader size={24} />}
                {
                    !props.fetching &&
                    props.error &&
                    props.services &&
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:update_error')}
                    >
                        <div>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                        </div>
                    </Tooltip>
                }
            </div>
            {
                props.error &&
                !props.services &&
                <div className={styles.cloudError}>
                    <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                    <span>{t('common:no_information_available')}</span>
                </div>
            }
            {
                props.services &&
                <div className={styles.informationContainer}>
                    {map(props.services, (service, index) =>
                        <div key={index}>
                            <ItemStatus error={service.status === '0'} item={t(service.name)} ok={service.status === '1'} />
                            {index !== totalServices && <Divider />}
                        </div>
                    )}
                </div>
            }
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.services === nextProps.services &&
        prevProps.error === nextProps.error &&
        prevProps.fetching === nextProps.fetching &&
        prevProps.title === nextProps.title &&
        prevProps.description === nextProps.description
);
